import { render, staticRenderFns } from "./MPopupUploadImgMovie.vue?vue&type=template&id=14128150&"
import script from "./MPopupUploadImgMovie.vue?vue&type=script&lang=ts&"
export * from "./MPopupUploadImgMovie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports